/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EquipmentTypeResponse
 */
export interface EquipmentTypeResponse {
    /**
     * 
     * @type {number}
     * @memberof EquipmentTypeResponse
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof EquipmentTypeResponse
     */
    equipmentCategoryId?: number;
    /**
     * 
     * @type {string}
     * @memberof EquipmentTypeResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof EquipmentTypeResponse
     */
    description?: string;
}

/**
 * Check if a given object implements the EquipmentTypeResponse interface.
 */
export function instanceOfEquipmentTypeResponse(value: object): value is EquipmentTypeResponse {
    return true;
}

export function EquipmentTypeResponseFromJSON(json: any): EquipmentTypeResponse {
    return EquipmentTypeResponseFromJSONTyped(json, false);
}

export function EquipmentTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EquipmentTypeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'equipmentCategoryId': json['equipmentCategoryId'] == null ? undefined : json['equipmentCategoryId'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function EquipmentTypeResponseToJSON(json: any): EquipmentTypeResponse {
    return EquipmentTypeResponseToJSONTyped(json, false);
}

export function EquipmentTypeResponseToJSONTyped(value?: EquipmentTypeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'equipmentCategoryId': value['equipmentCategoryId'],
        'name': value['name'],
        'description': value['description'],
    };
}

